import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const PanelWrapper = styled(FlexView)`
  gap: 24px;
  flex-wrap: wrap;
`;

export const StatCard = styled(FlexView)`
  gap: 4px;
  padding: 12px 20px;
  border-radius: 8px;
  background-color: ${COLORS.BLACK_T_08};
  min-width: 140px;
`;
